import { t } from "../../lib/sprache";
/**
 * Öffentliche Seiten der Demo zum Durchklicken (nur Demo-Datenbank, erfundene Daten). Der Link zum Dokument der Marke
 * entsteht beim Bau der Demo (scripts/demo-vertraege.ts) mit diesem festen Schlüssel; im Betrieb gibt es ihn nicht.
 * 0073: Freigabe-Link und Bericht für die Marke aus supabase/seed/demo_zz_freigabe_marke.sql (dort nur als Hash).
 */
export const DEMO_BRAND_DOCUMENT_TOKEN = "demo-dokument-der-marke-solviq-unterschreiben";
/** G5: Link der Marke Velune zum Kooperationsvertrag Studio-Serie (aus der Vorlage, mit Logo der Agentur); Film der Website */
export const DEMO_BRAND_SIGN_TOKEN = "demo-vertrag-studio-serie-velune-unterschreiben";
/** G5: Link der Schweizer Marke Kalmira zum englischen Kooperationsvertrag (englische Signierseite); Film der englischen Website */
export const DEMO_BRAND_SIGN_TOKEN_EN = "demo-agreement-kalmira-sign-in-english-00001";
export const DEMO_BRAND_REVIEW_TOKEN = "demo-freigabe-velune-lieblingsstueck-0000000001";
export const DEMO_BRAND_REPORT_TOKEN = "demo-bericht-solviq-morgenroutine-00000000001";

export const DEMO_PUBLIC_LINKS: readonly { label: string; detail: string; to: string }[] = [
  {
    get label() { return t("Vertrag der Marke unterschreiben (PDF)", "Sign the brand's contract (PDF)"); },
    get detail() { return t("Signierseite der Marke Solviq: PDF lesen, Lesen bestätigen, unterschreiben", "Brand signing page for Solviq: read the PDF, confirm reading, sign"); },
    to: `/unterschreiben?t=${DEMO_BRAND_DOCUMENT_TOKEN}`,
  },
  {
    get label() { return t("Vertrag aus der Vorlage unterschreiben (Marke)", "Sign the contract from the template (brand)"); },
    get detail() { return t("Signierseite der Marke Velune: Kooperationsvertrag Studio-Serie lesen, Name und Funktion angeben, unterschreiben", "Brand signing page for Velune: read the Studio-Serie cooperation agreement, enter name and position, sign"); },
    to: `/unterschreiben?t=${DEMO_BRAND_SIGN_TOKEN}`,
  },
  {
    get label() { return t("Englischen Vertrag unterschreiben (Marke)", "Sign the English agreement (brand)"); },
    get detail() { return t("Englische Signierseite der Schweizer Marke Kalmira: Kooperationsvertrag lesen und unterschreiben", "English signing page for the Swiss brand Kalmira: read and sign the cooperation agreement"); },
    to: `/unterschreiben?t=${DEMO_BRAND_SIGN_TOKEN_EN}`,
  },
  {
    get label() { return t("Entwurf freigeben (Marke)", "Approve draft (brand)"); },
    get detail() { return t("Freigabe-Link für Velune: Reel „Lieblingsstück“ von Noa Winter mit Briefing, freigeben oder Änderung wünschen", "Approval link for Velune: reel “Lieblingsstück” by Noa Winter with briefing, approve or request changes"); },
    to: `/freigabe/${DEMO_BRAND_REVIEW_TOKEN}`,
  },
  {
    get label() { return t("Bericht für die Marke", "Report for the brand"); },
    get detail() { return t("Bericht für Solviq: Morgenroutine mit Kennzahlen, Instagram-Werten, Screenshot und PDF", "Report for Solviq: morning routine with metrics, Instagram values, screenshot and PDF"); },
    to: `/bericht/${DEMO_BRAND_REPORT_TOKEN}`,
  },
];
